import React, { useEffect, useState } from "react";
import Header from "../../component/Header";
import Box from "../../component/Box/Box";
import TouchSlider from "../../component/TouchSlider/TouchSlider";
import SizeBox from "../../component/Box/SizeBox";
import { useDraggable } from "../../context/DrabbleContext";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  fetchTouchByTouchId,
  saveTouch,
} from "../../store/actions/projectAction";
import { getBase64FromUrl, MODULE } from "../../utils/global";
import { icon_mapping } from "../../assets/Icons/iconMapping";
import IconModal from "../../component/Partial/IconModal";
import { v7 as uuidv7 } from "uuid";

function TouchEdit() {
  const {
    design,
    setDesign,
    content,
    setContent,
    handleDrop,
    handleDragOver,
    handleDeleteElement,
    selectedIcons,
    handleSetSelectIcon,
    deleteSelectedicon,
    setSelectedIcons,
    setLogo,
    logo,
    handleTouchMove,
    handleTouchEnd,
  } = useDraggable();

  const [board, setBoard] = useState([]);

  const params = useParams();
  const dispatch = useDispatch();

  const init = async () => {
    if (params?.id) {
      const res = await dispatch(fetchTouchByTouchId(params?.id)).unwrap();
      if (res?.content) {
        // let parseDesign = JSON.parse(res?.design);
        let parseContent = JSON.parse(res?.content);
        const { design, content, selectedIcons } = parseContent;

        if (content) {
          setContent(content);
        }

        if (design) {
          setDesign(design);
        }

        if (selectedIcons) {
          setSelectedIcons(selectedIcons);
        }

        // if (res?.image) {
        //   const base64 = await getBase64FromUrl(res?.image);

        //   setLogo(base64);
        // } else {
        //   setLogo(null);
        // }
        if(!res?.image && !res?.image2 && !res?.image3) {
          setLogo(null);
        }

        setLogo({
          image: await getBase64FromUrl(res?.image),
          image2: await getBase64FromUrl(res?.image2),
          image3: await getBase64FromUrl(res?.image3),
        });
      } else {
        setContent([
          {
            key: 1,
            data: [],
            id: uuidv7(),
          },
        ]);
        setDesign({
          frame: "glass",
          color: "#171411",
          size: 1,
          varients: "",
        });
      }
    }
  };

  useEffect(() => {
    init();

    return () => {
      setContent(null);
      setLogo(null);
    };
  }, []);

  const handleSaveContent = async () => {
    const input = {
      design: design,
      content: content,
      selectedIcons: selectedIcons,
    };

    const res = await dispatch(
      saveTouch({
        id: params?.id,
        // design: designJson,
        content: JSON.stringify(input),
      })
    )
      .unwrap()
      .then((res) => {
        init();
      });
  };

  const modifiedHandleDrop = (e, index, key, isDownloadMode) => {
    e.stopPropagation();
    const { width, height } = MODULE[design?.size];

    let input = {
      width,
      height,
    };

    handleDrop(e, input, index, key, isDownloadMode);
    return;
  };

  const modifiedHandleTouchEnd = (e, index, key, isDownloadMode) => {
    e.stopPropagation();
    const { width, height } = MODULE[design?.size];

    let input = {
      width,
      height,
    };

    handleTouchEnd(e, input, index, key, isDownloadMode);
    return;
  };

  return (
    <div className="flex flex-col">
      <Header />
      <div className="w-full flex">
        <TouchSlider
          design={design}
          setDesign={setDesign}
          handleSaveContent={handleSaveContent}
        />
        <div
          className="w-[95%] h-screen flex justify-center items-center mt-16 "
          style={{
            height: "calc(100vh - 4rem)",
          }}
        >
          {design?.size && (
            <SizeBox
              {...design}
              board={board}
              modifiedHandleDrop={modifiedHandleDrop}
              modifiedHandleTouchEnd={modifiedHandleTouchEnd}
              handleDragOver={handleDragOver}
              handleTouchMove={handleTouchMove}
              handleDeleteElement={handleDeleteElement}
              content={content}
              selectedIcons={selectedIcons}
              handleSetSelectIcon={handleSetSelectIcon}
              deleteSelectedicon={deleteSelectedicon}
              logo={logo}
              setContent={setContent}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default TouchEdit;
